// import videoOne from 'assets/videos/02262025.mov';
import swRadioTwo from 'assets/audio/swRadio2.mp3';

export const initialTracks = [
  // {
  //   url: videoOne,
  //   metaData: {
  //     title: '02262025',
  //     artist: 'Local Video',
  //     album: 'Windows XP',
  //   },
  // },
  {
    url: swRadioTwo,
    metaData: {
      title: 'SW Radio Two',
      artist: 'Local Audio',
      album: 'Windows XP',
    },
  },
];
